import { render, staticRenderFns } from "./BillingInformation.vue?vue&type=template&id=08636f2a&"
import script from "./BillingInformation.vue?vue&type=script&lang=js&"
export * from "./BillingInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports